import { Brand, createBranded } from '@deltasierra/type-utilities';

export type CrmRecipientListId = Brand<number, 'CrmRecipientListId'>;
export const CrmRecipientListId = createBranded<CrmRecipientListId>();
